import React, {useCallback, useEffect,useState} from 'react';
import { useParams, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux';
import { getDmImei, getDms, logOut } from '../../redux/actions';
import DeviceDetalsHeader from './DeviceDetalsHeader';
import DmInfo from './DmInfo/DmInfo';
import DmCommands from './DmCommands/DmCommands';
import DmConfig from './DmConfig/DmConfig';
import PrepareMapData from "../MapData/PrepareMapData";
import CircleYandex from "../MapData/CircleYandex";
import DmGunSectors from './DmGunSectors/DmGunSectors';
import DmBarrier from './DmBarrier/DmBarrier';
import back from '../../img/nazad.png';
import Network from '../UI/Network/Network';
import './DeviceDetals.css';
import { jwtDecode } from 'jwt-decode';
import RsInfo from './RsInfo/RsInfo';
import RsCommands from './RsCommands/RsCommands';
import RsConfig from './RsConfig/RsConfig';
import RsDataModbus from './RsDataModbus/RsDataModbus';

  export default function DeviceDetals() {
    const dispatch = useDispatch();
    const { id } = useParams();
    const imei=id;
    const navigate = useNavigate();
    const role = useSelector((state) => state.userdata?.role);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);// Состояние для отслеживания ширины окна
    const token = localStorage.getItem('token'); // Предположим, что токен хранится в localStorage
    const data = useSelector((state) => state.dmimei?.data[0]);
    const [page, setPage] = useState('0');
    const [clickMup, setClickMup]=useState(false);

    // Функция для проверки срока действия токена
    const isTokenExpired = (token) => {
        try {
            const decoded = jwtDecode(token);
            return decoded.exp < Date.now() / 1000;
        } catch (e) {
            return true; // Если токен невалидный, считаем его просроченным
        }
    };

  useEffect(() => {// Функция, которая будет обновлять ширину окна при изменении размера
    const handleResize = () => {setWindowWidth(window.innerWidth)};
    // Добавляем слушатель изменения размера окна
    window.addEventListener('resize', handleResize);
    // Убираем слушателя при размонтировании компонента
    return () => {window.removeEventListener('resize', handleResize)};
    }, []);

    useEffect(() => {
        if (!token || isTokenExpired(token)) {
            localStorage.removeItem('token');
            navigate('/');
            return;
        }
    }, [token, navigate]);

  useEffect(() => {
    let isMounted = true;
    let intervalDms = null;
    let intervalImei = null;
    
    // Загрузка всех машин
    const fetchDms = async () => {
      if (!isMounted || document.hidden) return;
        try {
            await dispatch(getDms());
        } catch (error) {
            if (!isMounted) return;
            handleError(error);
        }
    };
    
    // Загрузка конкретной машины
    const fetchDmImei = async () => {
      if (!isMounted || document.hidden) return;
        try {
            await dispatch(getDmImei(imei));
        } catch (error) {
            if (!isMounted) return;
            handleError(error);
        }
    };
    
    // Общая обработка ошибок
    const handleError = (error) => {
        // console.error('Ошибка при получении данных:', error);
        
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            // console.log('Ошибка авторизации, очищаем токен');
            dispatch(logOut());
            
            // Очищаем оба интервала
            if (intervalDms) clearInterval(intervalDms);
            if (intervalImei) clearInterval(intervalImei);
            
            navigate('/');
        }
    };
    
    // Первый запуск
    fetchDms();
    fetchDmImei();
    
    // Запускаем интервалы с разной периодичностью
    intervalDms = setInterval(fetchDms, 10000);
    intervalImei = setInterval(fetchDmImei, 5000);
    
    return () => {
        isMounted = false;
        if (intervalDms) clearInterval(intervalDms);
        if (intervalImei) clearInterval(intervalImei);
    };
}, [imei]);

    const onClickPage = useCallback((index) => {          
    setPage(index);           
  }, [])
  
  const onClickBuck = useCallback ((e) => {
    e.preventDefault();
    const link= "/devices";
    navigate(link);
  },[navigate]) 

  const  onClickMup = useCallback((e) => {
    e.preventDefault();
    if (windowWidth < 768) {
      setClickMup(true);
    }
  }, [])

  const onClickBuckMup = useCallback((e) => {
    e.preventDefault();
    setClickMup(false);
  }, []);

  const mapData = PrepareMapData();

  const deviceName = useCallback((deviceType) => {
    return (deviceType === null || deviceType === undefined) ? 'Дм' : deviceType;
    },[])

  const isDm = data?.type === 'секторная' || data?.type === 'круговая';
  const isRs485 = data?.type === 'RS485';
  const isNormalImei = String(data?.imei).slice(0,3)!=="555"
  //Функции рендеры
  const renderMainTab = () => {
    return (
      <>
        {isDm && (
          <>
            <DmInfo />
            <DmCommands />
          </>
        )}
        {isRs485 && (
          <>
            <RsInfo />
            <RsCommands />
          </>
        )}
        {isNormalImei && (
          <Network 
            imei={data?.imei}
            phone = {data?.Phone}
            balans = {data?.balans}
            operator_name = {data?.operator_name}
          />
        )}
      </>
    );
    };

  const renderConfigTab = () => {
    return (
      <>
        {isDm && <DmConfig />}
        {isRs485 && <RsConfig />}
      </>
    );
  };

  return (
    <div className='mainCard'> 
    {(clickMup) ? (
      <div className='mainMupMini'>
        <div className='mainMupMiniHeader'> 
          <div className='mainMupMiniHeaderNavBuckMap'> 
            <button onClick={onClickBuckMup} ><img src={back} alt="Result" /></button>
          </div>
          <h3>{data?.imei_name}</h3>
        </div>
        <div className='mainContentMupMini'> 
          <CircleYandex mapData = {mapData} />
        </div>
      </div> 
    ) : (
        <div className='dmDetalsCard'>
          <DeviceDetalsHeader 
              onClickPage={onClickPage}
              onClickBuck={onClickBuck}
              onClickMup={onClickMup}
              imei_name={data?.imei_name}
              typeDevice={data?.type}
              role = {role}
          />
           <div className='dmDetalMainContent'>
              {page === '0' && renderMainTab()}
              {page ==='1' && renderConfigTab()}
              {page === '2' && isDm && <DmBarrier />}
              {page === '2' && isRs485 && <RsDataModbus />}
              {page === '3' && isDm && <DmGunSectors />}
            </div>
            <div className='dmConfigCardFooter'>
              <span className='dmConfigCardFooterparam'>{`imei: ${data?.imei}`}</span>
              <span className='dmConfigCardFooterparam'>{role===1 ? (`user: ${data?.username}, device: ${deviceName(data?.typeRsDevice_name)}`) : ('') }</span>
            </div>
        </div>
    ) }
        <div className='mainMup'>
          <CircleYandex mapData = {mapData} />
        </div>
     </div>
  );
};